import React, { useEffect, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Alert from '@mui/material/Alert';
import { hideSnackbar } from '../../redux/snackbarSlice';
import CheckCircleRoundedIcon from '@mui/icons-material/CheckCircleRounded';
import ErrorRoundedIcon from '@mui/icons-material/ErrorRounded';
import WarningRoundedIcon from '@mui/icons-material/WarningRounded';
import { AlertTitle, Badge, Fade } from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import Collapse from '@mui/material/Collapse';

const getSeverityIcon = (severity) => {
  switch (severity) {
    case 'success':
      return <CheckCircleRoundedIcon fontSize="inherit" />;
    case 'error':
      return <ErrorRoundedIcon fontSize="inherit" />;
    case 'warning':
      return <WarningRoundedIcon fontSize="inherit" />;
    default:
      return null;
  }
};

const SnackbarComponent = () => {
  const dispatch = useDispatch();
  const snackbars = useSelector((state) => state.snackbar.queue);
  const [mode, setMode] = useState(localStorage.getItem('mode') || 'light');
  const timerRefs = useRef({});

  useEffect(() => {
    const interval = setInterval(() => {
      setMode(localStorage.getItem('mode') || 'light');
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    snackbars.forEach((snackbar) => {
      const { id } = snackbar;

      // Don't set a timer if it already exists
      if (!timerRefs.current[id]) {
        timerRefs.current[id] = setTimeout(() => {
          dispatch(hideSnackbar(id));
          delete timerRefs.current[id];
        }, 6000);
      }
    });

    // Cleanup on unmount
    return () => {
      Object.values(timerRefs.current).forEach(clearTimeout);
      timerRefs.current = {};
    };
  }, [snackbars, dispatch]);

  const [expandedIds, setExpandedIds] = useState({});
  const toggleExpand = (id) => {
    setExpandedIds((prev) => {
      const isNowExpanded = !prev[id];

      if (isNowExpanded && timerRefs.current[id]) {
        clearTimeout(timerRefs.current[id]);
        delete timerRefs.current[id];
      }

      return {
        ...prev,
        [id]: isNowExpanded,
      };
    });
  };

  return (
    <div style={{
      position: 'fixed',
      top: 16,
      left: 0,
      right: 0,
      zIndex: 1400,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      gap: 12,
      pointerEvents: 'none',
    }}>
      {snackbars.map((snackbar) => (
        <Fade in key={snackbar.id}>
          <div style={{ pointerEvents: 'auto' }}>
          <Badge badgeContent={snackbar.count === 1 ? 0 : snackbar.count} color="primary">
            <Alert
              icon={getSeverityIcon(snackbar.severity)}
              severity={snackbar.severity}
              variant="outlined"
              onClose={() => dispatch(hideSnackbar(snackbar.id))}
              sx={{
                border: '1px solid',
                borderColor: 'divider',
                backgroundColor: mode === 'light' ? 'white' : 'black',
                color: mode === 'light' ? 'black' : 'white',
                minWidth: 300,

                alignItems: 'flex-start',
              }}
            >
              <AlertTitle><div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}> {snackbar.message} {snackbar.response && (
                    <span
                      onClick={() => toggleExpand(snackbar.id)}
                      style={{ cursor: 'pointer', marginLeft: 'auto' }}
                    >
                      {expandedIds[snackbar.id] ? <ExpandLessIcon /> : <ExpandMoreIcon />}
                    </span>
                  )}</div></AlertTitle>
              <div style={{ width: '100%' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                 
                </div>
                {snackbar.response && (
                  <Collapse in={expandedIds[snackbar.id]}>
                    <pre style={{
                      whiteSpace: 'pre-wrap',
                      wordBreak: 'break-word',
                      marginTop: 8,
                      fontSize: '0.85rem',
                      backgroundColor: mode === 'light' ? '#f5f5f5' : '#1e1e1e',
                      padding: 8,
                      borderRadius: 4,
                    }}>
                      {typeof snackbar.response === 'string'
                        ? snackbar.response
                        : JSON.stringify(snackbar.response, null, 2)}
                    </pre>
                  </Collapse>
                )}
              </div>
            </Alert>
            </Badge>
          </div>
        </Fade>
      ))}
    </div>
  );
};

export default SnackbarComponent;
